import React, {Fragment} from "react";

export default function Base({}) {
	return <Fragment><path fill="none" d="M33.78,85H85V15H15.004l0.016,50.855C15.02,76.414,23.436,85,33.78,85z"/><path d="M100,100V65.859V34.141C100,25.65,100,0,100,0S76.46,0,66.25,0H0l0.02,65.859C0.02,84.68,15.16,100,33.78,100h32.47H100z    M85,85H33.78c-10.344,0-18.76-8.586-18.76-19.145L15.004,15H85V85z"/></Fragment>
}